const SvgComponent = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="5.69995" y="3" width="12.6" height="18" rx="2" stroke="#111" strokeWidth="2"/>
  </svg>
)
export default SvgComponent
